import * as React from 'react'
import FindIcon from '../icons/ui/Find'

export interface IMobilityOptionsSearchProps {
  onInputChange: (query: string) => void
}

const MobilityOptionsSearch = ({ onInputChange }: IMobilityOptionsSearchProps) => {
  return (
    <div className='flex items-center mr3'>
      <input className='MobilityOptionsSearchInput mr1' type='text' onChange={createOnChangeHandler()} />
      <FindIcon className='svg-stroke-grey3' />
    </div>
  )

  function createOnChangeHandler() {
    return (e: any) => onInputChange(e.target.value)
  }
}

export default MobilityOptionsSearch



// WEBPACK FOOTER //
// ./src/components/mobility-options/MobilityOptionsSearch.tsx